import { Component } from '@angular/core';

@Component({
  selector: 'app-bom-explorer',
  templateUrl: './bom-explorer.component.html',
  styleUrl: './bom-explorer.component.css'
})
export class BomExplorerComponent {

}
